import { ChangeDetectionStrategy, Component, ElementRef, input, output, viewChildren } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type KontoReiterId = 'profil' | 'integrationen' | 'api';

export const KONTO_REITER: readonly KontoReiterId[] = ['profil', 'integrationen', 'api'];

@Component({
  selector: 'app-konto-reiter',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
  templateUrl: './konto-reiter.component.html',
  styleUrl: './konto-reiter.component.scss',
})
export class KontoReiterComponent {
  readonly aktiv = input.required<KontoReiterId>();
  readonly fehlend = input(0);
  readonly gewaehlt = output<KontoReiterId>();

  protected readonly reiter = KONTO_REITER;
  private readonly buttons = viewChildren<ElementRef<HTMLButtonElement>>('reiterButton');

  protected onKeydown(event: KeyboardEvent, index: number): void {
    const ziel = this.zielIndex(event.key, index);
    if (ziel === null) return;
    event.preventDefault();
    this.gewaehlt.emit(this.reiter[ziel]);
    this.buttons()[ziel].nativeElement.focus();
  }

  private zielIndex(key: string, index: number): number | null {
    const anzahl = this.reiter.length;
    switch (key) {
      case 'ArrowRight':
        return (index + 1) % anzahl;
      case 'ArrowLeft':
        return (index - 1 + anzahl) % anzahl;
      case 'Home':
        return 0;
      case 'End':
        return anzahl - 1;
      default:
        return null;
    }
  }
}
